import { SocketClient } from './SocketClient'
import { getCookie } from '../../utils/Cookie'
import { EUserLogsReasons } from '@devglobalbot/global-contracts'

export class LiveSocket extends SocketClient {
  private reconnecting = false

  constructor(store: any, router: any, emitter: any) {
    super({
      url: process.env.VUE_APP_SOCKET_LIVE!,
      namespace: 'live',
      auth: {},
    })

    this.registerEvents(store, router, emitter)
  }

  private registerEvents(store: any, router: any, emitter: any) {
    this.on('connect', () => {
      console.info('[LIVE] connected')
      store.commit('main/disableWarningLostConnection')

      const wasReconnect = this.reconnecting
      this.reconnecting = false

      // Restaura o status sem cair em -5 (offline) por acidente:
      //  1) cookie 'livestatus' (última escolha manual do operador)
      //  2) senão, o status atual do store (preservado porque o disconnect não o
      //     sobrescreve mais para -5)
      // Só reenvia changeStatus quando há um status válido a restaurar.
      const statusCookie = getCookie('livestatus')
      let status: number | null = null
      let reasonStatus: EUserLogsReasons = wasReconnect
        ? EUserLogsReasons.PANEL_SYS_RECONNECT
        : EUserLogsReasons.PANEL_SYS_CONNECT

      if (statusCookie != null && statusCookie !== '') {
        status = Number(statusCookie)
        if (!wasReconnect) reasonStatus = EUserLogsReasons.PANEL_SYS_COOKIE_CONNECT
      } else {
        const stored = store.state.main?.zion?.status
        if (typeof stored === 'number') status = stored
      }

      if (status != null && !Number.isNaN(status)) {
        this.emit('changeStatus', { status, reasonCode: reasonStatus })
      }

      if (wasReconnect) {
        const route = router.currentRoute.value
        if (route?.path?.startsWith('/live') && route.params?._id) {
          this.emit('enterRoom', { roomId: route.params._id })
        }
        // Ressincroniza o painel após reconectar: eventos em tempo real (novas
        // salas/mensagens) perdidos durante a queda são refeitos via REST,
        // independente do socket.
        emitter.emit('resyncLivePanel')
      }
    })

    this.on('disconnect', (reason: string) => {
      console.log('[LIVE] disconnected:', reason)
      // 'io client disconnect' = desconexão intencional (logout/close): não é queda.
      if (reason !== 'io client disconnect') {
        // No socket.io v4 o evento 'reconnect' é do Manager e não dispara no
        // socket; então marcamos aqui que o próximo 'connect' é uma reconexão.
        this.reconnecting = true
        // NÃO sobrescreve o status para -5: mantém o último status real no store
        // e apenas sinaliza a perda de conexão (banner). Assim o reconnect
        // restaura o status certo em vez de reanunciar offline.
        store.commit('main/enableWarningLostConnection')
      }
    })

    this.on('changeStatus', (e: any) => {
      if (e?.status !== undefined && e?.userId) {
        if (store.state.main.user._id === e.userId) {
          store.commit('main/setZion', { status: e.status })
        }
        // O mapa de status em main.users era alimentado pelo listener do drawer de atendentes, que
        // ficava montado desde o login. Com o drawer sob demanda, o commit precisa viver aqui: quem
        // consome esse status e o proprio getAttendants (filtro) e o connectedUsers do dashboard.
        store.commit('main/updateUserStatus', { userId: e.userId, status: e.status })
        emitter.emit('changeStatusAttendantsDrawer', e)
      }
    })
  }
}
